/*eslint no-unused-vars: "off"*/

jQuery(document).ready(function ($) {

    // Global variables
    var desktopL = 991,
        tabletM = 768,
        mobileS = 480,
        mobileXS = 319;


    //
    // Carousels
    //

    function initCarousel(elemClass, variableWidth, centerPadd, slidesL, slidesM, slidesS, slidesXS) {

        var numberOfElements = $(elemClass).children().length,
            settingsL,
            settingsM,
            settingsS,
            settingsXS,
            slidesToShowL = slidesL || 3,
            slidesToShowM = slidesM || 2,
            slidesToShowS = slidesS || 2,
            slidesToShowXS = slidesXS || 1,
            centerPadding = centerPadd,
            variWidth = variableWidth || false;

        // Use unslick in cases where there are too few elements
        if (slidesToShowL >= numberOfElements) {
            settingsL = 'unslick'
        } else {
            settingsL = {
                slidesToShow: slidesToShowL,
            }
        }

        if (slidesToShowM >= numberOfElements) {
            settingsM = 'unslick'
        } else {
            settingsM = {
                slidesToShow: slidesToShowM,
            }
        }

        if (slidesToShowS >= numberOfElements) {
            settingsS = 'unslick'
        } else {
            settingsS = {
                slidesToShow: slidesToShowS,
            }
        }

        if (slidesToShowXS >= numberOfElements) {
            settingsXS = 'unslick'
        } else {
            settingsXS = {
                slidesToShow: slidesToShowXS,
            }
        }

        // Responsive settings
        var responsive = [
            {
                breakpoint: desktopL,
                settings: settingsL,
            },
            {
                breakpoint: tabletM,
                settings: settingsM,
            },
            {
                breakpoint: mobileS,
                settings: settingsS,
            },
            {
                breakpoint: mobileXS,
                settings: settingsXS,
            },
        ];


        var options = {
            slidesToShow: 1,
            autoplay: true,
            dots: false,
            prevArrow: $('.btn-prev'),
            nextArrow: $('.btn-next'),
            appendArrows: false,
            arrows: true,
            infinite: true,
            mobileFirst: true,
            variableWidth: variWidth,
            responsive: responsive,
            centerMode: true,
            centerPadding: centerPadding,
        };

        $(elemClass).slick(options);

        $(window).on('resize orientationchange', function () {
            $(elemClass).slick('resize');
        });
    }


    // Carousels inits

    //Product images gallery carousels
    initCarousel('.products-slider', false, '20%', 1, 1, 1, 1);
    initCarousel('.gallery-wrapper.image-wrapper', false, '0px', 1, 1, 1, 1);



    //
    // Slider Banners
    //

    function initSlider(elemClass, autoplay) {
        var autoPlay = autoplay || false,
            options = {
            $sliderMode: true,
            slidesToShow: 1,
            autoplay: autoPlay,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            infinite: true,
        };

        $(elemClass).slick(options);
    }

    // images slider - no autoplay
    initSlider('.images-slider');

    initCarousel('.tab-content .tab-pane:first-child', false, '20%', 1, 1, 1, 1);

    $('.gallery-item a').on('shown.bs.tab', function (e) {
        var tabContent = $(this).attr('href');
        initCarousel(tabContent, false, '20%', 1, 1, 1, 1);
    })

});



// WEBPACK FOOTER //
// ./scripts/custom/slick-inits.js